import { Controller } from 'stimulus';
import Swiper, { Navigation, EffectFade } from 'swiper';

class QuotesSlider extends Controller {
  connect() {
    Swiper.use([Navigation, EffectFade]);

    this.swiper = new Swiper(this.element, {
      slidesPerView: 1,
      grabCursor: true,
      autoHeight: true,
      loop: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }
}

export default QuotesSlider;
